import CopyRight from '@/components/CopyRight/CopyRight.vue';

export default {
	name: 'Docs',

	components: {
		CopyRight
	}
};